import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cookie, CheckCircle, Settings } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import PageHeader from '../common/PageHeader';
import Footer from '../common/Footer';

const Cookies = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PageHeader />

      {/* Content */}
      <div className="container max-w-4xl py-16">
        <div className="flex items-center gap-3 mb-6">
          <Cookie className="h-10 w-10 text-primary" />
          <div>
            <h1 className="text-4xl font-bold">Cookiepolicy</h1>
            <p className="text-muted-foreground mt-2">Uppdaterad: {new Date().toLocaleDateString('sv-SE')}</p>
          </div>
        </div>

        <Card className="mb-8">
          <CardHeader>
            <CardTitle>Vi använder cookies på dekalio.nu</CardTitle>
            <CardDescription className="text-base">
              för att webbplatsen ska fungera korrekt, för att förbättra användarupplevelsen 
              och för att förstå hur tjänsten används.
            </CardDescription>
          </CardHeader>
        </Card>

        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Vad är cookies?</h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Cookies är små textfiler som sparas i din webbläsare när du besöker en webbplats. 
              De hjälper oss att känna igen din enhet och komma ihåg val du gjort.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-2xl font-semibold mb-6">Vilka typer av cookies använder vi?</h2>
            
            <div className="grid gap-4">
              <Card>
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <CheckCircle className="h-6 w-6 text-green-600" />
                    <div>
                      <CardTitle className="text-xl">Nödvändiga cookies</CardTitle>
                      <Badge variant="outline" className="mt-2">Kan inte avaktiveras</Badge>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Krävs för att webbplatsen och designverktyget ska fungera.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <Settings className="h-6 w-6 text-blue-600" />
                    <div>
                      <CardTitle className="text-xl">Analyscookies</CardTitle>
                      <Badge variant="outline" className="mt-2">Valfri</Badge>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Hjälper oss att förstå hur webbplatsen används, så att vi kan förbättra tjänsten.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <Cookie className="h-6 w-6 text-purple-600" />
                    <div>
                      <CardTitle className="text-xl">Funktionscookies</CardTitle>
                      <Badge variant="outline" className="mt-2">Valfri</Badge>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Används för att komma ihåg inställningar och val du gjort.
                  </p>
                </CardContent>
              </Card>
            </div>
          </section>

          <Separator />

          <section>
            <h2 className="text-2xl font-semibold mb-4">Hantering av cookies</h2>
            <Card>
              <CardContent className="pt-6">
                <p className="text-muted-foreground leading-relaxed">
                  Du kan när som helst blockera eller radera cookies via inställningarna i din webbläsare. 
                  Vissa funktioner på webbplatsen kan då sluta fungera som tänkt.
                </p>
              </CardContent>
            </Card>
          </section>

          <div className="flex gap-4 pt-8">
            <Button onClick={() => navigate('/')}>
              Tillbaka till startsidan
            </Button>
            <Button variant="outline" onClick={() => navigate('/integritetspolicy')}>
              Läs integritetspolicyn
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Cookies;

